import React from 'react';
import Product from "../components/Product";
import {ProfilesIcon2, ProfilesIcon3} from "../assets/imageAssets";

const TOPICS = [
    {
        id: 1,
        title: 'Household Size',
        description: 'Report your household size and see how it compares to national and European averages.',
    },
    {
        id: 2,
        title: 'Living Arrangement',
        description: 'Describe your living situation and discover how it matches broader lifestyle patterns.',
    },
    {
        id: 3,
        title: 'Home Ownership Status',
        description: 'Indicate your ownership status and compare it with trends across countries and age groups.',
    },
    {
        id: 4,
        title: 'Number of Generations in Home',
        description: 'Share your household composition and see how it reflects current multi-generational trends.',
    },
    {
        id: 5,
        title: 'Urban vs. Rural Living',
        description: 'Identify your living environment and compare it to population distribution in other regions.',
    },
];

const HouseholdInsight = () => {
    return (
        <Product
            title={'Household Insight'}
            description={'Understand family size trends and how household structure shifts across EU nations.'}
            icon={ProfilesIcon3}
            pageColor={'blue'}
            topicsList={TOPICS}
        />
    );
}

export default HouseholdInsight;
